// src/sections/Navbar.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import { decode } from "html-entities";
import CarNavbar from "../components/CarNavbar";
import shareIcon from "../img/shareIcon.png";

const Navbar = ({ contenuti, breadCrumbs }) => {
  const location = useLocation();
  // Percorsi in cui la wave è nera
  const specialPaths = ["/azienda"];
  const waveColor = specialPaths.includes(location.pathname) ? "#000" : "#fff";

  // Trasforma l'oggetto in array
  const contenutiArray = Array.isArray(contenuti)
    ? contenuti
    : contenuti && typeof contenuti === "object"
      ? Object.values(contenuti)
      : [];

  return (
    <>
      {contenutiArray.filter(Boolean).map((content, index) => {
        let {
          titolo_1,
          titolo_2,
          call_to_action_it,
          link_it,
          immagine_url,
          titolo_it,
          descrizione_it,
        } = content;

        // Decodifica eventuali entità HTML
        descrizione_it = decode(descrizione_it || "");

        // Costruisco le righe del titolo
        const rawTitle = String(titolo_1 ?? titolo_it ?? "");
        const titleLines = rawTitle.includes("|")
          ? rawTitle.split("|").map((s) => s.trim())
          : [rawTitle, titolo_2].filter(Boolean);

        return (
          <div
            key={index}
            className="h-nav d-flex flex-column position-relative"
            style={{
              backgroundImage: `url(${immagine_url})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* Overlay scuro */}
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50" />

            {/* Navbar */}
            <CarNavbar />

            {/* Contenuto centrale */}
            <div className="d-flex h-nav align-items-center ps-5 gap-4 z-2">
              {/* Icona share responsive */}
              <img
                src={shareIcon}
                alt="Share Icon"
                className="img-fluid d-block d-md-none"
                style={{ width: 48, height: 48 }}
              />
              <img
                src={shareIcon}
                alt="Share Icon"
                className="img-fluid d-none d-md-block"
                style={{ width: 128, height: 128 }}
              />

              {/* Testo */}
              <div>
                {/* Mobile: tutte le righe in un unico <p> con <br/> */}
                <p className="title-header-mobile d-block d-md-none">
                  {titleLines.map((line, idx) => (
                    <React.Fragment key={idx}>
                      {idx > 0 && <br />}
                      {line}
                    </React.Fragment>
                  ))}
                </p>

                {/* Desktop: una <p> per riga */}
                {titleLines.map((line, idx) => (
                  <p
                    key={idx}
                    className="title-header-desktop d-none d-md-block"
                  >
                    {line}
                  </p>
                ))}

                {/* Descrizione */}
                <p className="text-white text-21">{descrizione_it}</p>

                {/* Call to action / breadcrumbs */}
                <div className="mt-4 d-none d-md-flex">
                  {call_to_action_it ? (
                    <a
                      href={link_it}
                      className="btn btn-two text-uppercase"
                    >
                      {call_to_action_it}
                    </a>
                  ) : (
                    <p className="subtitle-text">{breadCrumbs}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Wave in fondo */}
            <div className="position-absolute w-100 navbar-onda">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 50"
                preserveAspectRatio="none"
                className="w-100"
              >
                <path
                  fill={waveColor}
                  d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                />
              </svg>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Navbar;
